import { CALL_API, Schemas } from '../../../common/middleware/api';

export const SAVED_QUERIES_REQUEST = 'SAVED_QUERIES_REQUEST';
export const SAVED_QUERIES_SUCCESS = 'SAVED_QUERIES_SUCCESS';
export const SAVED_QUERIES_FAILURE = 'SAVED_QUERIES_FAILURE';

export const SAVED_QUERY_CREATE_REQUEST = 'SAVED_QUERY_CREATE_REQUEST';
export const SAVED_QUERY_CREATE_SUCCESS = 'SAVED_QUERY_CREATE_SUCCESS';
export const SAVED_QUERY_CREATE_FAILURE = 'SAVED_QUERY_CREATE_FAILURE';

export const SAVED_QUERY_UPDATE_REQUEST = 'SAVED_QUERY_UPDATE_REQUEST';
export const SAVED_QUERY_UPDATE_SUCCESS = 'SAVED_QUERY_UPDATE_SUCCESS';
export const SAVED_QUERY_UPDATE_FAILURE = 'SAVED_QUERY_UPDATE_FAILURE';

export const SAVED_QUERY_DELETE_REQUEST = 'SAVED_QUERY_DELETE_REQUEST';
export const SAVED_QUERY_DELETE_SUCCESS = 'SAVED_QUERY_DELETE_SUCCESS';
export const SAVED_QUERY_DELETE_FAILURE = 'SAVED_QUERY_DELETE_FAILURE';

export const loadSavedQueries = ({ queryType }) => ({
	[CALL_API]: {
		types: [SAVED_QUERIES_REQUEST, SAVED_QUERIES_SUCCESS, SAVED_QUERIES_FAILURE],
		endpoint: `api/savedQueries/unpaged`,
		method: 'GET',
		request: { queryType },
		schema: Schemas.SAVED_QUERY_ARRAY
	},
	queryType
});

export const createSavedQuery = (query, onSuccessEvent) => ({
	[CALL_API]: {
		types: [SAVED_QUERY_CREATE_REQUEST, SAVED_QUERY_CREATE_SUCCESS, SAVED_QUERY_CREATE_FAILURE],
		endpoint: `api/savedQueries`,
		method: 'POST',
		request: query,
		schema: Schemas.SAVED_QUERY,
		form: 'savedQuery',
		onSuccessEvent
	}
});

export const updateSavedQuery = (id, query, onSuccessEvent) => ({
	[CALL_API]: {
		types: [SAVED_QUERY_UPDATE_REQUEST, SAVED_QUERY_UPDATE_SUCCESS, SAVED_QUERY_UPDATE_FAILURE],
		endpoint: `api/savedQueries/${id}`,
		method: 'PUT',
		request: query,
		schema: Schemas.SAVED_QUERY,
		form: 'savedQuery',
		onSuccessEvent
	}
});

export const deleteSavedQuery = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [SAVED_QUERY_DELETE_REQUEST, SAVED_QUERY_DELETE_SUCCESS, SAVED_QUERY_DELETE_FAILURE],
		endpoint: `api/savedQueries/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});